@if (showHeader()) {
  <app-impersonation-banner></app-impersonation-banner>
  <header class="header">
    <app-header ngClass="container"></app-header>
  </header>
}
<main class="main container">
  <router-outlet></router-outlet>
</main>
@if (showFooter()) {
  <footer class="footer">
    <app-footer ngClass="container"></app-footer>
  </footer>
}
